<script setup lang="ts">
import { defineProps, onMounted, ref } from 'vue'
import { generatePaymentQrCode } from '../../utilities/api'
import { getPlatformName } from '../../utilities/usePlatformSettings'

const props = defineProps<{
    amount: number
    reference: string
}>()

const qrCodeData = ref()

onMounted(async () => {
    qrCodeData.value = (
        await generatePaymentQrCode(getPlatformName(), {
            amount: props.amount,
            payment_reference: props.reference,
        })
    ).data
})
</script>

<template>
    <img :src="qrCodeData" class="w-full" alt="" />
</template>
